import React from 'react';
import './App.css';

// TODO - change h1 letter spacing to 0em
// TODO - change easeout to easeIn animation
// TODO - Apply same padding margin on both pic

function App() {
  return (
    <div>
      <section id="section1">
        <nav className="navbar navbar-expand-lg navbar-light bg-white">
          <div className="container-fluid ">
            {/* Brand */}
            <a className="navbar-brand mb-0" href="/">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="116"
                height="64"
                fill="none"
                viewBox="0 0 116 64"
              >
                <path
                  fill="#7442D3"
                  d="M87.616 28.125c-1.066 2.118-4.936 2.727-8.052 2.717-2.896 0-4.162-.382-6.316-1.157.492-3.555 2.322-18.929 24.208-27.794.826-.33 1.726-.703 2.646-1.013.523 1.323.795 2.728.816 4.144-.011 6.612-6.683 10.952-13.375 13.07 3.587-.103 9.234-1.23 13.343-2.139v.114c-.01 5.92-6.724 9.795-12.57 9.784-1.913-.04-3.816-.32-5.657-.816 1.13 1.602 3.012 2.48 4.957 3.09z"
                />
                <path
                  fill="#000"
                  d="M9.659 55.042H4.462V30.926h17.275v4.516H9.659v5.093h11.816v4.516H9.66v9.99zM28.879 55.04h-4.654V30.925h4.643V55.04h.01zM32.79 61.88l.69-4.123c.44.197.93.29 1.464.29 1.244 0 2.06-.424 2.457-1.271l.66-1.478-7.174-17.72h4.977l4.612 12.151 4.611-12.15h5.01l-8.304 20.323c-.606 1.54-1.464 2.624-2.562 3.234-1.098.61-2.478.95-4.13.992-.858 0-1.632-.083-2.311-.248zM66.828 52.819c-1.705 1.766-3.974 2.655-6.808 2.655-2.834 0-5.093-.889-6.787-2.655-1.694-1.767-2.54-3.947-2.54-6.53s.846-4.753 2.54-6.51c1.694-1.756 3.964-2.634 6.787-2.634 2.834 0 5.103.878 6.807 2.634 1.705 1.757 2.563 3.927 2.563 6.51 0 2.583-.858 4.752-2.563 6.53zm-10.102-2.893c.805.97 1.903 1.467 3.294 1.467 1.39 0 2.5-.486 3.315-1.467.815-.972 1.223-2.19 1.223-3.637 0-1.426-.408-2.625-1.223-3.596-.816-.971-1.924-1.467-3.315-1.467-1.39 0-2.489.486-3.294 1.467-.805.971-1.203 2.18-1.203 3.596 0 1.446.398 2.655 1.203 3.637zM88.683 55.04H84.04v-2.2c-1.59 1.756-3.66 2.634-6.222 2.634-1.903 0-3.325-.486-4.277-1.447-.952-.96-1.433-2.314-1.433-4.05V37.58h4.643v10.59c0 2.15 1.088 3.224 3.252 3.224 1.632 0 2.98-.662 4.026-1.994v-11.82h4.643V55.04h.01zM98.858 55.474c-1.632 0-2.876-.413-3.734-1.23-.857-.816-1.275-2.004-1.275-3.544v-9.113H90.92V37.58h2.928v-4.774h4.684v4.774h3.587v4.008h-3.587v7.884c0 .558.147 1.013.44 1.374.292.362.68.537 1.171.537.732 0 1.265-.165 1.61-.506l.994 3.472c-.868.754-2.165 1.126-3.89 1.126zM106.951 31.483h-1.359v4.205h-.617v-4.205h-1.36v-.569h3.336v.569zm5.48 4.215h-.617v-3.947l-1.642 3.947h-.178l-1.641-3.947v3.947h-.617v-4.773h.941l1.401 3.471 1.401-3.471h.941v4.773h.011z"
                />
              </svg>
            </a>
            {/* Toggler */}
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            {/* Collapse */}
            <div className="collapse navbar-collapse" id="navbarCollapse">
              {/* Toggler */}
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <i
                  style={{ backgroundColor: '#F6F6F6', color: '#7442d3' }}
                  class="fas fa-2x fa-times px-3 py-1 "
                ></i>
              </button>
              {/* Navigation */}
              <ul className="navbar-nav ml-md-9 mt-3">
                <li className="nav-item ">
                  <a
                    className="nav-link "
                    id="navbarLandings"
                    href="#section2"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Why Flyout
                  </a>
                </li>
                <li className="nav-item ">
                  <a
                    className="nav-link "
                    id="navbarPages"
                    href="#section3"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Monthly Stats
                  </a>
                </li>

                <li className="nav-item ">
                  <a
                    className="nav-link "
                    id="navbarAccount"
                    href="#section3"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Success Stories
                  </a>
                </li>
                <li className="nav-item contactNavItem">
                  <a
                    className="nav-link "
                    id="navbarDocumentation"
                    data-toggle="dropdown"
                    href="index.html#"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Contact Us
                  </a>
                </li>

                <li
                  style={{ borderTop: '0px solid #f1f4f8' }}
                  className="nav-item mal-md-11 pl-md-0 pl-md-0 pl-5"
                >
                  <a
                    className="nav-link "
                    id="navbarDocumentation"
                    data-toggle="dropdown"
                    href="https://dash-flyout.netlify.app/app/login"
                    target="_blank"
                  >
                    Sign In
                  </a>
                </li>

                <li className="ml-6 ml-md-4">
                  <a
                    id="get-started"
                    className="navbar-btn btn btn-primary lift ml-auto  mt-3 pt-3"
                    href="https://dash-flyout.netlify.app/app/login"
                    target="_blank"
                  >
                    Get Started
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <div style={{ paddingTop: '96px' }}>
          <div className="container-fluid pr-0 ">
            <div className="row align-items-center">
              <div className="col-12 col-md-5 col-lg-6 order-md-2 px-0">
                {/* Image */}

                <svg
                  id=" hero_illustration"
                  className="img-fluid mw-100 mw-md-110 mb-6 mb-md-0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="544"
                  height="424"
                  fill="none"
                  viewBox="0 0 544 424"
                >
                  <g clip-path="url(#prefix__clip0)">
                    <circle cx="249" cy="211" r="211" fill="#FFE2DD" />
                    <path
                      fill="#1A181E"
                      d="M186.41 287h-11.22V102h23.09l-10-36h-29.9l-10 36h23.08v185h-11.14c-2.866.012-5.614 1.143-7.659 3.15-2.045 2.008-3.226 4.735-3.291 7.6v.25c.33 2.58 10.93 4.65 24 4.65s23.63-2.07 24-4.65h.06c0-1.446-.285-2.878-.839-4.214-.554-1.336-1.366-2.55-2.39-3.571-1.023-1.022-2.238-1.832-3.575-2.383-1.337-.552-2.77-.835-4.216-.832z"
                    />
                    <path
                      fill="#1A181E"
                      stroke="#1A181E"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M402 27.628v190.727L545 242V4L402 27.628zm139.268 54.61l-72.721 4.134V20.114l72.721-11.621v73.746zm-72.721 11.114l72.695-3.354v66.635l-72.695-3.416V93.352zm-5.903 59.55l-58.246-2.715V96.303l58.272-2.68-.026 59.279zm0-131.886v65.68l-58.272 3.32V30.367l58.272-9.352zm-58.246 135.468l58.272 3.337v65.076l-58.272-9.309v-59.104zm64.149 69.385v-65.681l72.695 4.204v73.098l-72.695-11.621z"
                    />
                    <path
                      fill="#FF664D"
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M267.71 177.84s-29.74-3.52-49.3 11.74-36.38 79-36 109.54c.38 30.54 11.74 45.77 40.3 58.29 28.56 12.52 81.76 7.82 111.49-1.57 29.73-9.39 39.51-42.25 39.12-59.85-.39-17.6-19.95-37.95-26.6-42.25-6.65-4.3-25.43-13.3-34.82-27.39s-23.07-44.59-44.19-48.51z"
                    />
                    <path
                      fill="#000"
                      d="M339.66 353.76c-11.24-1.51-24.57-4.57-34.66-10.69-21.31-12.94-26.63-37.29-34.24-46.42-7.61-9.13-21.31-8.37-27.39-18.26-6.08-9.89 3.8-82.94-13.7-87.5-3.55-1.024-7.225-1.549-10.92-1.56l-.34.25c-19.56 15.26-36.38 79-36 109.54.38 30.54 11.74 45.77 40.3 58.29 28.56 12.52 81.76 7.82 111.49-1.57 1.859-.587 3.682-1.282 5.46-2.08z"
                      opacity=".13"
                    />
                    <path
                      fill="#1A181E"
                      stroke="#1A181E"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M256.07 191.63s-19.4 3.71-22.83 7.14c-3.43 3.43-17.69 57.06-17.69 57.06s6.28-1.71 12 .57 6.27 8.28 6.84 11.13c.458 3.407.745 6.834.86 10.27 0 0 57.68-5.15 69.95-8 12.27-2.85 30.94-4.17 30.94-4.17s-31.55-71.14-36.4-73.71c-4.85-2.57-25.11-2.86-28-2.28-2.89.58-15.67 1.99-15.67 1.99z"
                    />
                    <path
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M236.95 257.55l4.85-39.67M240.66 228.44l6.56-8.56M260.35 233.58s18.55-6 30.82-6"
                    />
                    <path
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M277.85 217.22l-1.24 9.51s3.14 0 3.43 1.43c.29 1.43-1.14 2.84-1.14 2.84s8.84 4.85 10 10.56"
                    />
                    <path
                      fill="#0F4C81"
                      d="M254.55 187.07c-1 1.77-.85 10.66-.62 17.06 2.42-3.13 7.43-9 10.34-7.92 3.69 1.42 5.11 11.94 5.11 11.94l-2.5-27.21h-.16s-10.65 3.46-12.17 6.13z"
                    />
                    <path
                      fill="#151117"
                      d="M276 216.93c-.127 0-.25-.042-.35-.12 0 0-2.49-1.91-5.12-3.79-2.39-1.71-5.94-5.32-5.94-8.26 0-2.16-.6-3.52-1.68-3.83-.75-.21-4.56 3.1-5.79 6l-.53 1.27c-1.3 3.12-1.67 3.93-2.41 3.78-.74-.15-.62-.91-.62-1.28s-.05-1.47-.1-2.88c-.4-9.71-.6-19 .55-21 1.59-2.77 11.38-6 12.5-6.34 2.5-.63 7.69-1.93 12.09 1.43 2.53 1.93 3.25 4.31 4 6.84.433 1.723 1.106 3.375 2 4.91.86 1.317 1.809 2.573 2.84 3.76 1.32 1.55 2.2 2.58 1.57 3.84-.069.149-.173.279-.304.379-.13.099-.284.165-.446.191-.79.11-1.58-.69-2.8-2-.25-.26-.56-.6-.82-.85 0 .27 0 .57-.05.9-.09 2-.22 5-1.32 6.77-1.32 2.07-6.63 9.77-6.86 10.1-.091.125-.227.211-.38.24l-.03-.06z"
                    />
                    <path
                      fill="#fff"
                      d="M266.72 181s-10.65 3.42-12.17 6.09c-1.52 2.67-.38 21.3-.38 23.59 0 2.29 1.33-1.34 2.47-4 1.14-2.66 5.14-6.66 6.47-6.28 1.33.38 2.09 1.91 2.09 4.38 0 2.47 3 5.9 5.71 7.8 2.71 1.9 5.13 3.8 5.13 3.8s5.52-8 6.85-10.08 1.14-6.47 1.33-8c.19-1.53 3.62 4.19 4.38 2.66.76-1.53-1.71-2.85-4.38-7s-1.9-8.56-5.9-11.61c-4-3.05-8.56-2.13-11.6-1.35z"
                    />
                    <path
                      fill="#fff"
                      d="M263 199.79c.103-.011.207-.011.31 0 .94.27 2.51 1.27 2.51 4.93 0 2.14 2.78 5.41 5.47 7.33 1.95 1.4 3.82 2.81 4.67 3.45 1.22-1.77 5.38-7.81 6.5-9.57.93-1.46 1.06-4.31 1.14-6.2 0-.63.06-1.18.11-1.55.006-.161.06-.316.154-.446s.225-.229.376-.284c.62-.2 1.22.44 2.2 1.51.511.604 1.091 1.144 1.73 1.61.18-.55-.33-1.19-1.45-2.51-1.067-1.223-2.046-2.519-2.93-3.88-.963-1.617-1.687-3.365-2.15-5.19-.74-2.45-1.37-4.56-3.61-6.26-4-3-8.6-1.87-11.1-1.24-2.92.94-10.68 3.8-11.84 5.82-1.16 2.02-.61 15.36-.4 20.38 0 .8.06 1.48.07 2 .29-.63.61-1.4.86-2l.54-1.28c1.04-2.51 4.84-6.62 6.84-6.62z"
                    />
                    <path
                      fill="#FFDFDA"
                      d="M254.55 187.07c-1 1.77-.85 10.66-.62 17.06 2.42-3.13 7.43-9 10.34-7.92 3.69 1.42 5.11 11.94 5.11 11.94l-2.5-27.21h-.16s-10.65 3.46-12.17 6.13z"
                    />
                    <path
                      fill="#0F4C81"
                      d="M214.82 271.81s-2.28-6.54-1.14-8.81c1.14-2.27 5.68-5.69 8.53-9.1 2.85-3.41-6.66 1.93-7.11 0-.36-1.55 5-4.65 7.12-5.8-6.64 1.27-13 5.89-13.23 7.73-.29 2.29-2.28 14.56-.86 16.27.74.88 2.55 1.68 5.57 1.79.69-1.2 1.12-2.08 1.12-2.08z"
                    />
                    <path
                      fill="#fff"
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M241.52 258.12S235 248.7 227 247.84c-8-.86-17.69 5.71-18 8-.31 2.29-2.28 14.56-.86 16.27 1.42 1.71 6.85 3.14 17.41-.29s14.83-7.71 15.97-13.7z"
                    />
                    <path
                      fill="#0F4C81"
                      d="M241.64 259.5c16.32-8.16 39.54-17.65 39.54-17.65-1.71 0-41.66 10-47.65 12.27-5.99 2.27-14.27 6.56-14.27 6.56s-10.71 4.25-11.13 12.56c-.23 4.59 7.42 6.56 15.41 6.56s19.4-10 26.82-14.27l4.5-2.6c-10.86 1.41-25.47 2.69-13.22-3.43z"
                    />
                    <path
                      fill="#fff"
                      d="M241.64 259.5c16.32-8.16 39.54-17.65 39.54-17.65-1.71 0-41.66 10-47.65 12.27-5.99 2.27-14.27 6.56-14.27 6.56s-10.71 4.25-11.13 12.56c-.23 4.59 7.42 6.56 15.41 6.56s19.4-10 26.82-14.27l4.5-2.6c-10.86 1.41-25.47 2.69-13.22-3.43z"
                      opacity=".5"
                    />
                    <path
                      fill="#FFDFDA"
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M219.26 260.68s-10.71 4.25-11.13 12.56c-.23 4.59 7.42 6.56 15.41 6.56s19.4-10 26.82-14.27c7.42-4.27 24.54-14.26 26.54-15.12 2-.86 8.84 1.43 11.7 2.28 2.86.85 8.27.86 8.27.86s4 6.28 6 6.28-4.28-9.42-5.13-11.42c-.85-2-14.84-6.56-16.55-6.56-1.71 0-41.66 10-47.65 12.27-5.99 2.27-14.28 6.56-14.28 6.56z"
                    />
                    <path
                      fill="#fff"
                      stroke="#151117"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M302.71 197.22L294 246.13l62.77.29 9.36-46.42c.081-.411.072-.835-.026-1.242-.099-.408-.285-.789-.546-1.117-.26-.328-.589-.596-.964-.784-.374-.189-.785-.293-1.204-.307l-57.75-1.74c-.698-.024-1.381.208-1.92.652-.539.443-.898 1.069-1.01 1.758z"
                    />
                    <path
                      fill="#0F4C81"
                      d="M294.02 246.13l-30.57 21.62 69.91-2 23.43-19.33-62.77-.29z"
                    />
                    <path
                      fill="#fff"
                      d="M294.02 246.13l-30.57 21.62 69.91-2 23.43-19.33-62.77-.29z"
                      opacity=".5"
                    />
                    <path
                      fill="#FFDFDA"
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M294.02 246.13l-30.57 21.62 69.91-2 23.43-19.33-62.77-.29z"
                    />
                    <path
                      fill="#0F4C81"
                      d="M317.13 267.53s25.11-22 49.93-29.39c24.82-7.39 30-6.28 29.39 4.85-.61 11.13-12.55 69.34-20.54 84.18-7.99 14.84-18 41.94-17.69 47.08.31 5.14 10 20.26 18.55 25.68 8.55 5.42 7.7 12 2.28 13.12-5.42 1.12-11.7 3.14-30.25-8.84s-26.25-29.11-25.11-33.39c1.14-4.28 13.13-10 18-18.54 4.87-8.54 12.84-40.52 13.41-55.07.462-9.187 2.389-18.241 5.71-26.82 0 0-31.39 5.7-40.52 11.41l-3.16-14.27z"
                    />
                    <path
                      fill="#fff"
                      d="M317.13 267.53s25.11-22 49.93-29.39c24.82-7.39 30-6.28 29.39 4.85-.61 11.13-12.55 69.34-20.54 84.18-7.99 14.84-18 41.94-17.69 47.08.31 5.14 10 20.26 18.55 25.68 8.55 5.42 7.7 12 2.28 13.12-5.42 1.12-11.7 3.14-30.25-8.84s-26.25-29.11-25.11-33.39c1.14-4.28 13.13-10 18-18.54 4.87-8.54 12.84-40.52 13.41-55.07.462-9.187 2.389-18.241 5.71-26.82 0 0-31.39 5.7-40.52 11.41l-3.16-14.27z"
                      opacity=".5"
                    />
                    <path
                      fill="#fff"
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M317.13 267.53s25.11-22 49.93-29.39c24.82-7.39 30-6.28 29.39 4.85-.61 11.13-12.55 69.34-20.54 84.18-7.99 14.84-18 41.94-17.69 47.08.31 5.14 10 20.26 18.55 25.68 8.55 5.42 7.7 12 2.28 13.12-5.42 1.12-11.7 3.14-30.25-8.84s-26.25-29.11-25.11-33.39c1.14-4.28 13.13-10 18-18.54 4.87-8.54 12.84-40.52 13.41-55.07.462-9.187 2.389-18.241 5.71-26.82 0 0-31.39 5.7-40.52 11.41l-3.16-14.27z"
                    />
                    <path
                      fill="#fff"
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M341.67 352.28c-.371.643-.775 1.267-1.21 1.87 5.904.553 11.501 2.886 16.05 6.69 1.365 1.187 2.667 2.446 3.9 3.77 3.34-10.67 9.91-27.06 15.5-37.44 8-14.84 20-73.05 20.54-84.18.54-11.13-4.56-12.27-29.39-4.85-24.83 7.42-49.93 29.39-49.93 29.39l3.14 14.27c9.13-5.71 40.52-11.41 40.52-11.41-3.321 8.579-5.248 17.633-5.71 26.82-.57 14.55-8.56 46.51-13.41 55.07z"
                    />
                    <path
                      fill="#263238"
                      d="M341.67 352.28c-.371.643-.775 1.267-1.21 1.87 5.904.553 11.501 2.886 16.05 6.69 1.365 1.187 2.667 2.446 3.9 3.77 5.47-7.34 11.62-30.53 18.56-40.07 17.94-24.64 16.91-70.42 17.48-81.55.57-11.13-4.56-12.27-29.39-4.85-24.83 7.42-49.93 29.39-49.93 29.39l3.14 14.27c9.13-5.71 40.52-11.41 40.52-11.41-3.321 8.579-5.248 17.633-5.71 26.82-.57 14.55-8.56 46.51-13.41 55.07z"
                    />
                    <path
                      fill="#fff"
                      d="M341.67 352.28c-.371.643-.775 1.267-1.21 1.87 5.904.553 11.501 2.886 16.05 6.69 1.365 1.187 2.667 2.446 3.9 3.77 5.47-7.34 11.62-30.53 18.56-40.07 17.94-24.64 16.91-70.42 17.48-81.55.57-11.13-4.56-12.27-29.39-4.85-24.83 7.42-49.93 29.39-49.93 29.39l3.14 14.27c9.13-5.71 40.52-11.41 40.52-11.41-3.321 8.579-5.248 17.633-5.71 26.82-.57 14.55-8.56 46.51-13.41 55.07z"
                      opacity=".53"
                    />
                    <path
                      fill="#000"
                      d="M384.39 241.49c-.45-4.06-44.58 14.62-63.19 22.69-2.59 2.06-4.07 3.35-4.07 3.35l3.14 14.27c9.13-5.71 40.52-11.41 40.52-11.41-3.321 8.579-5.248 17.633-5.71 26.82-.57 14.55-8.56 46.51-13.41 55.07-.371.643-.775 1.267-1.21 1.87 3.132.339 6.198 1.134 9.1 2.36 6.91-14.62 14.24-31.56 17.71-44.83 6.28-23.97 17.73-65.06 17.12-70.19z"
                      opacity=".14"
                    />
                    <path
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M360.79 270.39s8.56-17.41 16-24.54"
                    />
                    <path
                      stroke="#151117"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M341.67 352.28c-.371.643-.775 1.267-1.21 1.87 5.904.553 11.501 2.886 16.05 6.69 1.365 1.187 2.667 2.446 3.9 3.77 5.47-7.34 11.62-30.53 18.56-40.07 17.94-24.64 16.91-70.42 17.48-81.55.57-11.13-4.56-12.27-29.39-4.85-24.83 7.42-49.93 29.39-49.93 29.39l3.14 14.27c9.13-5.71 40.52-11.41 40.52-11.41-3.321 8.579-5.248 17.633-5.71 26.82-.57 14.55-8.56 46.51-13.41 55.07z"
                    />
                    <path
                      fill="#0F4C81"
                      d="M363.11 371.62c7.62 5.46 14.26 10.28 16.22 11.76 4.57 3.42 13.13 9.7 15.13 10 .7.11 3.79-3 7.68-7.49l-32.68-21-6.35 6.73z"
                    />
                    <path
                      fill="#fff"
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M242.37 272.1s-9.13 5.13-12.27 10.84c-3.14 5.71 10.37 15.22 24.64 14.65 14.27-.57 40.42-16.08 40.42-16.08s.29 25.11 5.14 34.24c4.85 9.13 27.1 31.39 35.95 37.1 8.85 5.71 38.52 27.1 43.08 30.53 4.56 3.43 13.13 9.7 15.13 10 2 .3 22.82-25.1 27.67-33.66 4.85-8.56 9.13-26.54 7.42-30.54-1.71-4-5.13-.57-8.56 2.29-3.43 2.86-34.81 23.68-37.66 25.11-1.558.801-3.18 1.47-4.85 2 0 0-25.68-24.58-39.38-43.4-13.7-18.82-14.84-43.08-20-52.21-5.16-9.13-12.56-13.13-23.68-12-11.12 1.13-34.22 7.15-53.05 21.13z"
                    />
                    <path
                      fill="#FFDFDA"
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M363.11 371.62c7.62 5.46 14.26 10.28 16.22 11.76 4.57 3.42 13.13 9.7 15.13 10 .7.11 3.79-3 7.68-7.49l-32.68-21-6.35 6.73z"
                    />
                    <path
                      fill="#263238"
                      d="M376.71 356.84c-6-5.89-28.67-36.26-37.61-53.72-13.09-25.59-14.5-34.31-19.63-43.44-5.13-9.13-12.9-9.84-24-8.7-11.1 1.14-31 3.21-55.47 17.06 0 0-10.26 5.58-13.4 11.29-3.14 5.71 8.29 20.07 28.16 18.26 14.22-1.3 40.42-16.08 40.42-16.08s.29 25.11 5.14 34.24c4.85 9.13 27.1 31.39 35.95 37.1 5.61 3.62 19.59 13.54 30.24 21.2 2.65-9.56 7.36-14.79 10.2-17.21z"
                    />
                    <path
                      fill="#fff"
                      d="M376.71 356.84c-6-5.89-28.67-36.26-37.61-53.72-13.09-25.59-14.5-34.31-19.63-43.44-5.13-9.13-12.9-9.84-24-8.7-11.1 1.14-31 3.21-55.47 17.06 0 0-10.26 5.58-13.4 11.29-3.14 5.71 8.29 20.07 28.16 18.26 14.22-1.3 40.42-16.08 40.42-16.08s.29 25.11 5.14 34.24c4.85 9.13 27.1 31.39 35.95 37.1 5.61 3.62 19.59 13.54 30.24 21.2 2.65-9.56 7.36-14.79 10.2-17.21z"
                      opacity=".53"
                    />
                    <path
                      fill="#48D193"
                      d="M319.34 316.24c-8.56-21.68-3.43-65.05-27.4-59.34-17.46 4.15-49.47 18.92-65.55 26.62 1.9 6.55 12.4 15.52 28.35 14.07 14.22-1.3 40.42-16.08 40.42-16.08s.29 25.11 5.14 34.24c4.85 9.13 27.1 31.39 35.95 37.1 5.61 3.62 19.59 13.54 30.24 21.2.916-3.346 2.26-6.559 4-9.56-21.27-15.7-46.38-36.14-51.15-48.25z"
                      opacity=".14"
                    />
                    <path
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M295.16 281.51l-.86-14.83M376.71 356.84c-6-5.89-28.67-36.26-37.61-53.72-13.09-25.59-14.5-34.31-19.63-43.44-5.13-9.13-12.9-9.84-24-8.7-11.1 1.14-31 3.21-55.47 17.06 0 0-10.26 5.58-13.4 11.29-3.14 5.71 8.29 20.07 28.16 18.26 14.22-1.3 40.42-16.08 40.42-16.08s.29 25.11 5.14 34.24c4.85 9.13 27.1 31.39 35.95 37.1 5.61 3.62 19.59 13.54 30.24 21.2 2.65-9.56 7.36-14.79 10.2-17.21z"
                    />
                    <path
                      fill="#1A181E"
                      stroke="#1A181E"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M379.33 383.38c4.57 3.42 13.13 9.7 15.13 10 2 .3 22.82-25.1 27.67-33.66 4.85-8.56 9.13-26.54 7.42-30.54-1.71-4-5.13-.57-8.56 2.29-3.43 2.86-34.81 23.68-37.66 25.11-.75.37-1.43.68-2 .94-.83 1.56-1.82 4-1.1 5.62 1.14 2.57 6 6 6 6l-8.63 12.95c.72.53 1.33.98 1.73 1.29z"
                    />
                    <path
                      fill="#0F4C81"
                      d="M394.75 393.29l.24-.13.08-.05.38-.28.14-.11.33-.28.18-.17c.15-.12.29-.26.45-.41l.27-.26.38-.37.32-.32.32-.32.81-.86.13-.13.51-.55.2-.22 1.89-2.1.06-.06.7-.8-5-3.21c-2.84 3.09-5.48 5.86-7.58 8l.77.5.11.07.71.44c.39.24.75.46 1.1.65l.31.18.32.17.37.19.25.12.35.15c.054.026.111.046.17.06.131.056.269.093.41.11.069.017.141.017.21 0l.11-.01z"
                    />
                    <path
                      fill="#fff"
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M422.13 359.7c4.85-8.56 9.13-26.54 7.42-30.54-1-2.31-2.56-2.13-4.37-1 1.21 5.34 0 15.63-5.9 26.7-5.26 9.89-21.51 27.36-29.7 35.87 2.22 1.46 4.08 2.54 4.88 2.65 1.99.27 22.82-25.12 27.67-33.68z"
                    />
                    <path
                      fill="#FFDFDA"
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M394.75 393.29l.24-.13.08-.05.38-.28.14-.11.33-.28.18-.17c.15-.12.29-.26.45-.41l.27-.26.38-.37.32-.32.32-.32.81-.86.13-.13.51-.55.2-.22 1.89-2.1.06-.06.7-.8-5-3.21c-2.84 3.09-5.48 5.86-7.58 8l.77.5.11.07.71.44c.39.24.75.46 1.1.65l.31.18.32.17.37.19.25.12.35.15c.054.026.111.046.17.06.131.056.269.093.41.11.069.017.141.017.21 0l.11-.01z"
                    />
                    <path
                      fill="#1A181E"
                      stroke="#1A181E"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M376.77 399.93c-8.56-5.42-18.27-20.55-18.55-25.68-.007-.566.037-1.132.13-1.69-1.703.066-3.345.656-4.7 1.69-3.51-3.19-7.224-6.146-11.12-8.85-3.48-2.25-8-2.88-10.24-3.06-4.14 3.4-8 6.16-8.6 8.48-1.14 4.28 6.57 21.4 25.11 33.39 18.54 11.99 24.83 10 30.25 8.84 5.42-1.16 6.28-7.7-2.28-13.12z"
                    />
                    <path
                      fill="#FFDFDA"
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M376.77 399.93c-2.835-1.925-5.395-4.226-7.61-6.84-5.89-2.5-13.75-5.75-20.64-10-7.42-4.56-5.71-7.42-10-11.7-3.28-3.28-9.75-3.71-12.58-3.73-1.007.847-1.784 1.934-2.26 3.16-1.14 4.28 6.57 21.4 25.11 33.39 18.54 11.99 24.83 10 30.25 8.84 5.42-1.16 6.29-7.7-2.27-13.12z"
                    />
                    <path
                      fill="#263238"
                      d="M378.19 401.92c-7.42-4.28-22.54-7.13-32.24-13.69-9.7-6.56-7.13-12.27-14.27-16.84-3.27-2.09-6-1.6-8-.45-1 4.45 6.74 21.38 25.13 33.27 18.55 12 24.83 10 30.25 8.84 3.6-.76 5.17-3.91 3.31-7.53-1.17-1.437-2.585-2.656-4.18-3.6z"
                    />
                    <path
                      fill="#fff"
                      d="M378.19 401.92c-7.42-4.28-22.54-7.13-32.24-13.69-9.7-6.56-7.13-12.27-14.27-16.84-3.27-2.09-6-1.6-8-.45-1 4.45 6.74 21.38 25.13 33.27 18.55 12 24.83 10 30.25 8.84 3.6-.76 5.17-3.91 3.31-7.53-1.17-1.437-2.585-2.656-4.18-3.6z"
                      opacity=".53"
                    />
                    <path
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M378.19 401.92c-7.42-4.28-22.54-7.13-32.24-13.69-9.7-6.56-7.13-12.27-14.27-16.84-3.27-2.09-6-1.6-8-.45-1 4.45 6.74 21.38 25.13 33.27 18.55 12 24.83 10 30.25 8.84 3.6-.76 5.17-3.91 3.31-7.53-1.17-1.437-2.585-2.656-4.18-3.6v0z"
                    />
                    <path
                      fill="#fff"
                      stroke="#151117"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M236 347.35s5.47-6.66 6.26-1.57-.4 14.47-4.31 18c-3.91 3.53-5.87-2-5.87-2l2.35-3.13s2 3.91 3.52-2.35-3.13-5.47-3.13-5.47l1.18-3.48z"
                    />
                    <path
                      fill="#fff"
                      stroke="#151117"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M231.81 372.38c-3.24 2.4-13.8 2.4-17 0-6.86-5.08-5.68-29.61-5.68-29.61h28.38s1.16 24.53-5.7 29.61z"
                    />
                    <path
                      stroke="#151117"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M212.18 338c0-3.09 2.86-3.09 2.86-6.18s-2.86-3.09-2.86-6.18 2.86-3.09 2.86-6.18-2.86-3.09-2.86-6.18 2.86-3.1 2.86-6.19M222 338c0-2.35 2.86-2.35 2.86-4.69 0-2.34-2.86-2.35-2.86-4.69 0-2.34 2.86-2.35 2.86-4.7s-2.86-2.35-2.86-4.7 2.86-2.35 2.86-4.7M232.76 338c0-3.09 2.86-3.09 2.86-6.18s-2.86-3.09-2.86-6.18 2.86-3.09 2.86-6.18-2.86-3.09-2.86-6.18 2.86-3.1 2.86-6.19"
                    />
                    <path
                      fill="#fff"
                      stroke="#151117"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M237.47 342.77c0 .71-6.35 1.29-14.19 1.29s-14.19-.58-14.19-1.29c0-.71 6.35-1.29 14.19-1.29s14.19.58 14.19 1.29z"
                    />
                    <path
                      fill="#0F4C81"
                      d="M282 178.82l-1.17-2.22c-2.09-1.15-5-2.83-7.78-4.69-5.09-3.42-8.67-7.27-9.37-5.72 0 0 1.33 14.41 1.89 19 .56 4.59 1.84 17.63 3.15 22 .443 1.265 1.059 2.463 1.83 3.56-1.38-8.61.12-24.15.12-24.15l11.33-7.78z"
                    />
                    <path
                      fill="#fff"
                      d="M263.66 166.19s1.33 14.41 1.89 19c.56 4.59 1.84 17.63 3.15 22 1.31 4.37 8.46 11.85 9.15 10.11.69-1.74 4.23-13.49 2.82-20.48-1.41-6.99-1.85-13.07-1-14.81.85-1.74 4-3.78 4-3.78-3.671-1.907-7.234-4.017-10.67-6.32-5.06-3.42-8.64-7.27-9.34-5.72z"
                    />
                    <path
                      fill="#151117"
                      d="M277.46 218.05c-2.21-.09-8.09-6.93-9.26-10.77-1.07-3.54-2.09-12.6-2.77-18.59-.15-1.39-.29-2.59-.4-3.46-.55-4.51-1.87-18.84-1.89-19-.008-.099.009-.199.05-.29.068-.16.172-.302.303-.415.132-.112.289-.193.457-.235 1-.24 2.27.73 4.89 2.77 1.34 1 2.85 2.22 4.55 3.37 3.439 2.257 6.998 4.327 10.66 6.2.092.044.171.113.228.198.056.086.089.185.094.287.005.102-.017.204-.065.295s-.119.167-.207.22c-.84.54-3.17 2.24-3.84 3.55-.67 1.31-.62 6.38 1 14.44 1.48 7.26-2.25 19.35-2.84 20.81-.07.194-.201.361-.375.473-.173.112-.379.163-.585.147zm-13.2-51.65c.18 2 1.35 14.53 1.86 18.68.11.88.24 2.08.4 3.47.63 5.59 1.68 14.95 2.73 18.39 1.15 3.82 6.76 9.73 8.12 10 .68-1.83 4.12-13.21 2.74-20.05-1.14-5.59-2.06-12.92-.92-15.18.902-1.37 2.072-2.544 3.44-3.45-3.404-1.776-6.715-3.725-9.92-5.84-1.74-1.16-3.27-2.35-4.62-3.41s-3.25-2.57-3.83-2.61z"
                    />
                    <path
                      fill="#0F4C81"
                      d="M277.9 167.94c-2.92-8.65-3.63-22.21-3.63-25.83 0-2.8 7.28-5.87 10.61-7.12-2.18-1.35-4.71-1.52-8-1.81-5.73-.52-17.22 4.15-19.24 9.69-2.02 5.54.28 13.41 1.95 18.06.883 2.566 2.065 5.019 3.52 7.31 0 0 8.22 6.88 14.53 9.37 4.347 1.638 9.051 2.09 13.63 1.31-4.44-1.7-11.43-5.21-13.37-10.98z"
                    />
                    <path
                      fill="#FFDFDA"
                      d="M282.55 178.82l-1.16-2.22c-2.1-1.15-5-2.83-7.79-4.69-5.08-3.42-8.66-7.27-9.36-5.72 0 0 1.33 14.41 1.89 19 .56 4.59 1.83 17.63 3.15 22 .443 1.263 1.056 2.461 1.82 3.56-1.38-8.61.12-24.15.12-24.15l11.33-7.78z"
                    />
                    <path
                      fill="#fff"
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M263.13 168.24s8.22 6.88 14.53 9.37c6.31 2.49 16 2.35 17.35-.93 1.35-3.28-2.39-29.22-5.64-36.05-3.25-6.83-6.73-6.93-12.47-7.45-5.74-.52-17.22 4.15-19.24 9.69-2.02 5.54.28 13.41 1.95 18.06.883 2.566 2.065 5.019 3.52 7.31z"
                    />
                    <path
                      fill="#FFDFDA"
                      d="M278 167.41c-2.91-8.66-3.62-22.21-3.62-25.84 0-2.79 7.28-5.86 10.61-7.11-2.18-1.35-4.72-1.52-8-1.82-5.74-.52-17.23 4.16-19.24 9.7-2.01 5.54.27 13.4 2 18.06.878 2.566 2.056 5.02 3.51 7.31 0 0 8.22 6.88 14.53 9.37 4.347 1.638 9.051 2.09 13.63 1.31-4.42-1.7-11.42-5.22-13.42-10.98z"
                    />
                    <path
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M290 151.29c.13 3.29-1.93 6-4.6 6.14-2.67.14-4.94-2.47-5.07-5.76-.13-3.29 1.93-6 4.6-6.14 2.67-.14 4.93 2.47 5.07 5.76zM296.44 150c.13 3.29-.93 6-2.37 6.06-1.44.06-2.7-2.57-2.83-5.85-.13-3.28.93-6 2.37-6.06 1.44-.06 2.7 2.6 2.83 5.85z"
                    />
                    <path
                      fill="#fff"
                      d="M290.32 150.11s9.43 1.79 8.52 4.06c-.91 2.27-7.28 4.73-7.28 4.73"
                    />
                    <path
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M290.32 150.11s9.43 1.79 8.52 4.06c-.91 2.27-7.28 4.73-7.28 4.73M289.74 149.06s.13-1.17 1.59-.42M280.05 152.21l-17.15 6.74"
                    />
                    <path
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M280.27 146.66c.363-.817.968-1.503 1.734-1.964.765-.462 1.654-.677 2.546-.616M291.69 144.16l-2.64 1"
                    />
                    <path
                      stroke="#263238"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M283.54 163.31s3.39-.9 5.37 1.12"
                    />
                    <path
                      fill="#263238"
                      d="M285.75 151.92c.16 1.14-.05 2.12-.47 2.17-.42.05-.88-.82-1-2-.12-1.18.06-2.12.47-2.17.41-.05.84.85 1 2z"
                    />
                    <path
                      fill="#1A181E"
                      stroke="#1A181E"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M264.51 159s-1.16 2.28 2.08 2.4c3.24.12 5.41-1.4 3.84-3.4-1.57-2-3.88-3.82-1.5-6.4 2.38-2.58 7-4.75 4.42-7.62s-12.18-.27-9.79-2.6c2.39-2.33 13.44-4.73 18.44-4.38 5 .35 14.27-3.54 16.3-8.59 2.03-5.05-.81-14.38-7.5-13.86-6.69.52-11.67 6.42-14.63 6.78-2.96.36-9.06-2.87-14.16.06s-5.27 11.14-5.73 12.15c-.46 1.01-7.28 2.46-8.55 9.46-.447 2.813-.243 5.691.596 8.412.839 2.722 2.291 5.215 4.244 7.288 2.86 3.12 4.15 4.31 4.15 4.31l7.79-4.01z"
                    />
                    <path
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width=".75"
                      d="M250 146.36c-.05 1.051.207 2.093.74 3M279.08 128.29s-2.49-5.45 3.86-5.45 7.26 7.95.68 10.9-20.87 3.63-28.59 7c-1.515.597-2.863 1.551-3.93 2.78M267.59 147.62c-2.28.82-5.24 2-8.25 3.36-6.35 3-5 5.9-5 5.9M271.82 146.22s-.55.16-1.5.47"
                    />
                    <path
                      fill="#0F4C81"
                      d="M265.6 161.44s-3.69-5.32-7.58-3.18-.86 9.72 1.48 12.36c2.34 2.64 6.86-2.25 7.31-3.51"
                    />
                    <path
                      fill="#fff"
                      d="M265.6 161.44s-3.69-5.32-7.58-3.18-.86 9.72 1.48 12.36c2.34 2.64 6.86-2.25 7.31-3.51"
                      opacity=".5"
                    />
                    <path
                      fill="#FFDFDA"
                      d="M265.6 161.44s-3.69-5.32-7.58-3.18-.86 9.72 1.48 12.36c2.34 2.64 6.86-2.25 7.31-3.51"
                    />
                    <path
                      stroke="#1A181E"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M265.6 161.44s-3.69-5.32-7.58-3.18-.86 9.72 1.48 12.36c2.34 2.64 6.86-2.25 7.31-3.51"
                    />
                    <path
                      fill="#fff"
                      stroke="#151117"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M219.76 156.59H136.5c-2.828 0-5.12 2.292-5.12 5.12v61.26c0 2.828 2.292 5.12 5.12 5.12h83.26c2.828 0 5.12-2.292 5.12-5.12v-61.26c0-2.828-2.292-5.12-5.12-5.12z"
                    />
                    <path
                      fill="#fff"
                      d="M223.09 208.02l54.79 14.27-54.79-26.82"
                    />
                    <path
                      stroke="#151117"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M223.09 208.02l54.79 14.27-54.79-26.82"
                    />
                    <path
                      fill="#FFC774"
                      stroke="#151117"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M160.94 163.46h-22v57.75h22v-57.75zM220.02 163.46h-2.75v57.75h2.75v-57.75z"
                    />
                    <path
                      fill="#151117"
                      stroke="#151117"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M220.02 189.87h-2.75v4.94h2.75v-4.94z"
                    />
                    <path
                      stroke="#151117"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M167.81 164.84h43.31M167.81 171.03h43.31M167.81 177.21h43.31M167.81 183.4h43.31M167.81 198.52h43.31M167.81 204.02h43.31M167.81 209.52h43.31M167.81 220.94h43.31M138.94 221.21l22-57.75"
                    />
                    <path
                      fill="#FFE2DD"
                      d="M475.596 418c11.186 0 20.255-4.001 20.255-8.936s-9.069-8.936-20.255-8.936c-11.187 0-20.256 4.001-20.256 8.936S464.409 418 475.596 418z"
                    />
                    <path
                      fill="#48D193"
                      d="M451.534 274.209c2.146.922 7.381.808 7.381.808s-1.12-3.388-1.225-3.595c-1.152-2.383-4.774-6.299-7.737-5.905-.488.08-.953.26-1.366.529-.413.27-.764.622-1.031 1.034-.266.412-.442.875-.516 1.359-.074.484-.045.978.087 1.45.492 2.03 2.586 3.491 4.407 4.32z"
                    />
                    <path
                      fill="#48D193"
                      d="M521.233 256.239c-3.027-.33-6.621 3.791-7.733 6.255-.096.223-1.198 3.717-1.145 3.717h.064c-.577.648-1.176 1.349-1.829 2.124-1.187 1.444-2.513 3.09-3.829 4.97-1.444 2.018-2.769 4.117-3.968 6.287-1.36 2.42-2.495 4.958-3.391 7.583v.095c0-.881 0-3.366-.054-3.557-.342-2.677-2.61-7.647-5.605-8.199-.499-.077-1.009-.048-1.497.084-.487.132-.942.364-1.333.681-.391.318-.711.714-.939 1.162-.227.448-.357.938-.381 1.439-.182 2.124 1.38 4.248 2.888 5.608 1.712 1.508 6.418 2.984 6.835 3.09-.851 2.694-1.522 5.439-2.011 8.22-.289 1.614-.524 3.25-.749 4.896v-1.54c-.353-2.676-2.609-7.646-5.605-8.199-.5-.076-1.01-.047-1.498.084-.489.132-.943.364-1.336.682-.392.317-.713.712-.941 1.16-.229.449-.36.939-.385 1.441-.172 2.124 1.379 4.248 2.898 5.597 1.519 1.348 5.552 2.697 6.621 3.037-.074.627-.16 1.264-.235 1.89-.374 3.038-.717 6.064-1.155 9.027-.15 1.062-.342 2.071-.535 3.091v-1.338c-.353-2.677-2.61-7.647-5.605-8.199-.5-.078-1.011-.051-1.5.08-.489.131-.945.363-1.337.681-.393.318-.714.714-.942 1.163-.228.449-.358.94-.382 1.443-.171 2.124 1.38 4.248 2.899 5.596 1.519 1.349 5.166 2.56 6.418 2.974-.225 1.062-.439 2.124-.706 3.09-.193.669-.332 1.338-.567 2.007l-.642 1.997c-.46 1.243-.93 2.538-1.401 3.738-.332.85-.653 1.646-.984 2.443.171-1.062.449-3.069.449-3.239-.033-2.377-.677-4.706-1.872-6.765.009-.263-.009-.527-.053-.786-.063-.499-.231-.978-.493-1.408-.262-.43-.613-.8-1.028-1.087-.416-.286-.888-.483-1.385-.576-.497-.094-1.009-.082-1.501.034-2.942.775-4.803 5.904-4.942 8.602 0 .159.096 1.89.171 2.984-.139-.637-.278-1.253-.439-1.901-.31-1.296-.652-2.581-1.069-3.951l-.61-2.007c-.182-.669-.471-1.359-.706-2.039-.588-1.582-1.251-3.186-1.957-4.726 1.134-.265 5.166-1.295 6.792-2.527 1.626-1.232 3.316-3.186 3.305-5.363.014-.503-.079-1.002-.273-1.466-.193-.464-.483-.883-.85-1.228-.368-.346-.804-.611-1.281-.778-.478-.167-.985-.233-1.489-.192-3.027.318-5.659 5.108-6.204 7.752 0 .17-.214 2.124-.3 3.186-.428-.934-.856-1.879-1.326-2.814-1.348-2.708-2.803-5.406-4.279-8.103l-1.305-2.485c.407-.085 5.231-1.2 7.039-2.581 1.615-1.221 3.326-3.186 3.305-5.373.014-.502-.079-1.001-.273-1.465-.194-.464-.484-.882-.851-1.226-.368-.345-.804-.609-1.282-.775-.477-.166-.984-.23-1.488-.188-3.027.319-5.658 5.108-6.204 7.753 0 .202-.299 2.995-.321 3.706-.952-1.816-1.893-3.642-2.738-5.48-1.153-2.476-2.146-5.023-2.974-7.625.193 0 5.231-1.179 7.082-2.591 1.615-1.232 3.326-3.239 3.305-5.374.013-.502-.08-1.002-.273-1.466-.194-.464-.484-.882-.851-1.228s-.804-.611-1.281-.778c-.477-.167-.984-.232-1.489-.192-3.027.329-5.648 5.119-6.204 7.763 0 .213-.31 3.186-.321 3.76-.053-.149-.117-.297-.16-.457-.753-2.629-1.268-5.319-1.54-8.039-.172-1.508-.246-2.952-.289-4.354.962-.117 5.348-.701 7.145-1.784 1.797-1.084 3.658-2.857 3.883-4.981.069-.498.032-1.005-.109-1.488-.141-.482-.383-.93-.71-1.314-.327-.383-.731-.694-1.188-.913-.456-.218-.953-.338-1.459-.353-3.038 0-6.182 4.471-7.027 7.041 0 .138-.343 1.604-.557 2.677v-1.891c0-2.294.15-4.386.3-6.234.085-1.062.192-2.007.299-2.899.877-.595 4.407-3.069 5.488-4.832 1.08-1.763 1.925-4.248 1.134-6.191-.17-.474-.437-.908-.786-1.272-.349-.364-.772-.651-1.24-.843-.468-.191-.972-.282-1.478-.267-.506.014-1.004.135-1.46.353-2.706 1.391-3.412 6.797-2.973 9.463 0 .233 1.069 3.759 1.069 3.727h.054c-.118.85-.235 1.763-.342 2.772-.193 1.848-.386 3.951-.439 6.245-.081 2.479-.02 4.961.182 7.434.216 2.76.678 5.497 1.38 8.177v.096c-.482-.744-1.894-2.794-2.011-2.932-1.787-2.039-6.418-4.949-9.231-3.77-.46.21-.871.513-1.205.89-.335.377-.586.82-.737 1.3-.151.479-.199.985-.141 1.484.058.499.221.981.478 1.413 1.07 1.869 3.519 2.793 5.53 3.08 2.268.329 7.039-1.062 7.413-1.147.788 2.709 1.757 5.362 2.899 7.944.652 1.508 1.358 3.005 2.139 4.503-.439-.637-.834-1.2-.899-1.264-1.775-2.05-6.417-4.949-9.231-3.77-.46.209-.87.513-1.205.89-.334.377-.584.82-.735 1.3-.15.48-.197.986-.137 1.485.059.499.224.98.484 1.412 1.069 1.869 3.519 2.793 5.519 3.08 2 .286 6.14-.797 7.22-1.062.278.563.556 1.136.845 1.709 1.38 2.73 2.771 5.449 4.054 8.157.449.955.867 1.911 1.273 2.867-.385-.563-.717-1.062-.77-1.062-1.776-2.05-6.418-4.949-9.231-3.77-.46.209-.871.513-1.205.89-.334.377-.585.82-.735 1.3-.151.48-.197.986-.138 1.485.06.499.225.98.484 1.412 1.07 1.869 3.508 2.793 5.519 3.08 2.011.286 5.734-.691 7.017-1.062.396.987.792 1.986 1.124 2.963.213.669.47 1.306.652 1.996.182.691.374 1.349.567 2.007.31 1.296.642 2.624.909 3.887.203.882.375 1.731.546 2.581-.439-.956-1.337-2.814-1.434-2.963-1.444-2.283-5.594-5.852-8.557-5.108-.487.137-.939.375-1.328.698-.388.323-.703.723-.925 1.175-.222.452-.346.945-.363 1.448-.017.502.072 1.003.263 1.468.738 1.997 3.048 3.293 4.984 3.877 2.14.648 6.878 0 7.488 0 .289 1.402.546 2.772.781 4.067.791 4.492 1.283 8.263 1.594 10.907.053.467.096.881.139 1.274h-9.167l2.952 57.093c.107 2.09 1.018 4.059 2.544 5.502 1.527 1.443 3.553 2.248 5.66 2.251 2.109-.003 4.136-.808 5.664-2.25 1.529-1.443 2.442-3.412 2.551-5.503l2.942-57.093h-8.558l.193-.382c1.166-2.432 2.792-5.915 4.546-10.174.556-1.349 1.134-2.793 1.701-4.248.567.117 5.263 1.062 7.487.574 1.979-.446 4.375-1.562 5.263-3.505.225-.451.352-.943.372-1.445.02-.503-.066-1.003-.254-1.47-.188-.467-.473-.89-.836-1.24s-.796-.621-1.271-.794c-2.889-.966-7.295 2.294-8.9 4.471-.096.127-.973 1.625-1.519 2.591l.695-1.837c.46-1.242.878-2.506 1.337-3.855l.61-2.007c.214-.659.353-1.391.535-2.124.396-1.636.717-3.314.995-5.013 1.069.404 5.027 1.763 7.07 1.614 2.043-.148 4.568-.881 5.734-2.665.293-.411.495-.879.593-1.373.098-.494.089-1.002-.025-1.493-.114-.49-.331-.951-.638-1.352-.306-.402-.694-.734-1.139-.975-2.706-1.381-7.563 1.168-9.488 3.079-.118.117-1.348 1.636-2 2.485.16-1.062.321-2.039.449-3.079.374-2.995.663-6.043.963-9.08l.288-2.783c.396.149 5.028 1.859 7.306 1.699 2.033-.138 4.568-.881 5.744-2.665.29-.412.489-.88.586-1.373.096-.493.087-1.001-.027-1.491-.114-.489-.33-.949-.635-1.351-.304-.401-.69-.735-1.132-.978-2.707-1.381-7.563 1.168-9.488 3.069-.15.148-1.915 2.336-2.332 2.92.214-2.039.449-4.078.77-6.074.411-2.697.997-5.365 1.754-7.987.182.075 5.006 1.88 7.349 1.721 2.021-.149 4.567-.882 5.733-2.676.291-.411.492-.878.589-1.371.097-.492.088-1-.026-1.489-.114-.489-.331-.949-.636-1.349-.305-.401-.692-.732-1.136-.974-2.706-1.391-7.562 1.168-9.487 3.069-.15.149-2.043 2.517-2.364 2.963.053-.149.075-.308.128-.467.842-2.607 1.916-5.133 3.209-7.551.685-1.349 1.423-2.591 2.139-3.791.867.425 4.835 2.347 6.953 2.421 2.118.074 4.642-.372 6.001-2.018.338-.377.592-.82.745-1.302.154-.481.203-.989.144-1.491-.059-.501-.223-.985-.484-1.419-.26-.433-.609-.808-1.026-1.098-2.545-1.678-7.648.329-9.776 2.018-.118.096-1.188 1.147-1.958 1.933.343-.531.696-1.062 1.07-1.604 1.273-1.901 2.556-3.568 3.701-5.034.663-.828 1.284-1.571 1.861-2.251 1.07 0 5.348-.149 7.263-1.062s3.936-2.453 4.386-4.535c.134-.498.158-1.02.07-1.528-.088-.509-.285-.992-.579-1.418-.293-.425-.676-.783-1.122-1.048-.446-.265-.944-.431-1.461-.487zm-33.523 80.775c-1.829 4.174-3.519 7.594-4.727 9.962-.246.478-.46.903-.664 1.285h-.171c-.064-.457-.128-.967-.203-1.529-.374-2.666-.952-6.457-1.861-10.981-.278-1.424-.61-2.942-.963-4.503 1.426-.563 2.815-1.212 4.161-1.944 1.562 1.678 5.552 3.643 6.076 3.887-.578 1.328-1.123 2.613-1.648 3.823z"
                    />
                    <path
                      fill="#48D193"
                      d="M505.509 275.021s.948-3.435.98-3.662c.379-2.607-.474-7.853-3.162-9.136-.454-.2-.944-.305-1.442-.308-.497-.003-.989.096-1.445.291-.455.195-.864.481-1.201.841-.336.359-.592.783-.751 1.245-.717 1.956.201 4.356 1.286 6.001 1.265 1.966 5.724 4.728 5.735 4.728z"
                    />
                    <path
                      fill="#1A181E"
                      d="M473.269 407.537l-3.972-57.26c-.161-2.313 1.672-4.277 3.99-4.277h17.898c2.328 0 4.164 1.981 3.988 4.303l-4.353 57.292c-.357 4.699-4.353 8.283-9.063 8.128-4.51-.149-8.176-3.684-8.488-8.186z"
                    />
                  </g>
                  <defs>
                    <clipPath id="prefix__clip0">
                      <path fill="#fff" d="M0 0H544V424H0z" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div
                id="Get-paid-col"
                className="col-12 col-md-7 col-lg-6 order-md-1 px-0"
              >
                {/* Heading */}
                <h1 id="Get-paid" className=" text-left mb-md-0 mb-5">
                  Get paid for something <br /> you're already doing.
                </h1>
                {/* Text */}
                <p
                  id="flyouts"
                  style={{ color: '#4d4d4d' }}
                  className="  text-lg-left  mb-8 margin-bottom-md-7"
                >
                  Flyout is a free, simple way to earn money by placing
                  sponsored content on your blog.
                </p>

                {/* Buttons */}
                <div class="input-group mb-3">
                  <input
                    name="email"
                    type="email"
                    class="form-control"
                    placeholder="Your email address..."
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    required
                    id="buttonssecondary"
                  />
                  <div class="input-group-append ml-5">
                    <button
                      class="btn bg-primary lift mr-1"
                      id="buttonsprimary"
                      onclick="form_step_1()"
                      type="submit"
                    >
                      Get Started
                    </button>
                  </div>
                </div>
              </div>
            </div>{' '}
            {/* / .row */}
          </div>{' '}
          {/* / .container */}
        </div>
      </section>

      <section style={{ marginTop: '120px' }}>
        <div className="container-fluid ">
          <div className="row align-items-center ">
            <h1 className="Join-over-1868-bloggers text-md-left text-center">
              Join over <b> 1868 bloggers </b>, who have chosen Flyout to
              monetize their blogs.
            </h1>
            <div className="col-12 slick-slider scrolling-wrapper px-0 justify-content-between">
              <div className="marquee">
                <ul className="marquee-image">
                  <li>
                    {' '}
                    <img
                      className="imgScroll"
                      src="assets/img/im/e6.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e7.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e8.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e9.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e10.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e11.png"
                      alt=""
                    />
                  </li>

                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e12.png"
                      alt=""
                    />
                  </li>

                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e13.png"
                      alt=""
                    />
                  </li>

                  <li>
                    {' '}
                    <img
                      className="imgScroll"
                      src="assets/img/im/e6.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e7.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e8.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e9.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e10.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e11.png"
                      alt=""
                    />
                  </li>

                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e12.png"
                      alt=""
                    />
                  </li>

                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e13.png"
                      alt=""
                    />
                  </li>

                  <li>
                    {' '}
                    <img
                      className="imgScroll"
                      src="assets/img/im/e6.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e7.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e8.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e9.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e10.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e11.png"
                      alt=""
                    />
                  </li>

                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e12.png"
                      alt=""
                    />
                  </li>

                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e13.png"
                      alt=""
                    />
                  </li>

                  <li>
                    {' '}
                    <img
                      className="imgScroll"
                      src="assets/img/im/e6.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e7.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e8.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e9.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e10.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e11.png"
                      alt=""
                    />
                  </li>

                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e12.png"
                      alt=""
                    />
                  </li>

                  <li>
                    <img
                      className="imgScroll "
                      src="assets/img/im/e13.png"
                      alt=""
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="section2">
        <div className="container-fluid ">
          <div className="row justify-content-center">
            <div id="why-cont" className="col-xl-5 col-12 text-center">
              <h1 className="Why-choose-Fly6">Why choose Flyout?</h1>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-xl-10 col-12 text-center ">
              <h1 className="Getting-started-with-Flyout">
                Getting started with Flyout takes literally 30 seconds. A 3 step
                process is what you need to follow to start monetizing your
                blog.
              </h1>
            </div>
          </div>

          <div
            style={{ marginTop: '48px' }}
            class="row justify-content-between"
          >
            <div class="col-sm-4 col33 ">
              <div class="card Rectangle-5 mx-auto mx-md-0 mb-6 mb-md-0  ">
                <div class="card-body text-center">
                  <svg
                    className="iconsbrandiconsetup mx-auto"
                    xmlns="http://www.w3.org/2000/svg"
                    width="88"
                    height="88"
                    fill="none"
                    viewBox="0 0 88 88"
                  >
                    <g clip-path="url(#prefix__clip0)">
                      <path
                        fill="#EA6F57"
                        fill-rule="evenodd"
                        d="M47.627 30.42l4.256 19.876.855-.077-.508-5.657c-.235-2.6 1.703-4.92 4.304-5.156 2.602-.234 4.92 1.703 5.156 4.305l.508 5.657 1.299-.117-.362-4.023c-.234-2.6 1.703-4.92 4.305-5.155 2.6-.235 4.92 1.702 5.155 4.304l.36 4.023.616-.055-.15-1.666c-.233-2.6 1.704-4.92 4.306-5.155 2.6-.234 4.92 1.703 5.155 4.304l1.61 17.907.016.83c.844 9.385-6.144 17.754-15.53 18.6l-5.38.483c-13.82 1.243-23.14-14.839-30.581-23.956-2.297-2.815-.274-6.294.678-6.682 2.023-1.652 5.03-1.347 6.68.677l3.417 4.185-5.452-25.464c-.551-2.57 1.255-5.276 3.649-5.638 2.554-.547 5.09 1.095 5.638 3.65zM72.167 5l5.096 9.634L88 16.503l-7.588 7.823 1.54 10.789-9.784-4.8-9.785 4.8 1.54-10.789-7.587-7.823 10.736-1.869L72.168 5zM12.75 7.308c7.042 0 12.75 5.708 12.75 12.75 0 7.041-5.707 12.75-12.75 12.75C5.708 32.807 0 27.098 0 20.057c0-7.042 5.709-12.75 12.75-12.75zm40.978.748v24.003h-3.85l-.434-2.024c-.38-1.778-1.453-3.238-2.872-4.157-1.398-.905-3.131-1.29-4.872-.944-.087.014-.192.034-.314.06-1.593.34-2.966 1.373-3.865 2.738-.818 1.244-1.255 2.779-1.112 4.327h-6.684V8.056h24.003z"
                        clip-rule="evenodd"
                      />
                    </g>
                    <defs>
                      <clipPath id="prefix__clip0">
                        <path fill="#fff" d="M0 0H88V88H0z" />
                      </clipPath>
                    </defs>
                  </svg>

                  <div className="row justify-content-center">
                    <div className="col-xl-7 col-12">
                      <p class="Quick-Setup">Quick Setup</p>
                    </div>
                  </div>

                  <div className="row justify-content-center  ">
                    <div className="col-12 col33">
                      <div className="d-flex flex-column"></div>
                      <p class="Easy-to-use">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          className="mr-1"
                          fill="none"
                          viewBox="0 0 18 18"
                        >
                          <path
                            fill="#17B31B"
                            d="M14.232 3.732c.476-.476 1.248-.476 1.724 0 .439.44.473 1.13.1 1.609l-.1.115-8.38 8.378c-.439.44-1.13.474-1.608.102l-.115-.102-3.809-3.808c-.475-.476-.475-1.248 0-1.724.44-.44 1.131-.473 1.61-.101l.114.101 2.947 2.946 7.517-7.516z"
                          />
                        </svg>{' '}
                        Easy to use
                      </p>

                      <p class="Easy-to-use">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          className="mr-1"
                          fill="none"
                          viewBox="0 0 18 18"
                        >
                          <path
                            fill="#17B31B"
                            d="M14.232 3.732c.476-.476 1.248-.476 1.724 0 .439.44.473 1.13.1 1.609l-.1.115-8.38 8.378c-.439.44-1.13.474-1.608.102l-.115-.102-3.809-3.808c-.475-.476-.475-1.248 0-1.724.44-.44 1.131-.473 1.61-.101l.114.101 2.947 2.946 7.517-7.516z"
                          />
                        </svg>{' '}
                        Kick-ass product
                      </p>

                      <p class="Easy-to-use">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          className="mr-1"
                          fill="none"
                          viewBox="0 0 18 18"
                        >
                          <path
                            fill="#17B31B"
                            d="M14.232 3.732c.476-.476 1.248-.476 1.724 0 .439.44.473 1.13.1 1.609l-.1.115-8.38 8.378c-.439.44-1.13.474-1.608.102l-.115-.102-3.809-3.808c-.475-.476-.475-1.248 0-1.724.44-.44 1.131-.473 1.61-.101l.114.101 2.947 2.946 7.517-7.516z"
                          />
                        </svg>{' '}
                        100% free for blog registration
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4 col33 ">
              <div class="card Rectangle-5 mx-auto mx-md-0 mb-6 mb-md-0  ml-0 ml-md-4">
                <div class="card-body text-center">
                  <svg
                    className="iconsbrandiconsetup mx-auto"
                    xmlns="http://www.w3.org/2000/svg"
                    width="88"
                    height="88"
                    fill="none"
                    viewBox="0 0 88 88"
                  >
                    <path
                      fill="#FFC774"
                      fill-rule="evenodd"
                      d="M25.428 56.957l.611.01c1.022.03 2.052.129 3.014.211l3.708.328c4.942.452 9.88.964 14.817 1.49l7.404.794.695.075c1.855.206 3.724.456 5.524.928l.227.062c2.396.691 3.892 2.284 3.656 5.04l-.034.297c-.099.689-.33 1.35-.67 1.951l-.122.203c-.885 1.405-2.394 2.44-4.237 2.635l-.504.04c-1.685.096-3.422-.181-5.121-.354l-2.768-.28c-2.767-.291-5.531-.61-8.301-.91v.004h-.004l-.086.849-.086.85.47.227c2.208 1.017 4.54 1.51 6.92 1.877l1.526.223c1.021.143 2.049.279 3.077.439l.433.064c7.902 1.09 13.719-2.292 18.994-7.552h.001l.015-.015.015-.015.497-.497c1.323-1.332 2.65-2.687 4.157-3.776l.204-.141c2.48-1.636 6.134-1.248 7.579.604l.145.2c.84 1.223 1.016 2.885.599 4.477l-.08.28c-.374 1.203-1.092 2.35-2.119 3.207l-1.043.861c-3.84 3.14-7.832 6.108-11.443 9.486l-.317.29c-3.493 3.111-7.39 3.988-11.977 3.901l-2.64-.033c-3.52-.028-7.042.003-10.562.034l-1.947.018c-5.84.049-11.677.067-17.497-.22l-.578-.023c-4.99-.156-9.4.93-13.583 2.904l-.578-.502C7.872 82.603 3.294 76.645 0 69.948l1.932-1.144c6.441-3.812 12.89-7.616 19.512-11.084 1.126-.59 2.531-.763 3.984-.763zm35.429-28.592l.295.004c6.275.155 11.315 5.267 11.315 11.551 0 6.383-5.198 11.557-11.61 11.557l-.295-.003c-6.277-.156-11.317-5.269-11.317-11.554l.004-.293c.156-6.248 5.293-11.262 11.608-11.262zM34.965 3.76L51.58 15.203 40.08 31.738 23.468 20.295 34.965 3.76zm49.614-.774L83.03 28.53 61.357 15.176l23.222-12.19z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <div className="row justify-content-center">
                    <div className="col-xl-7 col-12">
                      <p class="Quick-Setup">Full Control</p>
                    </div>
                  </div>

                  <div className="row justify-content-center  ">
                    <div className="col-12 ">
                      <div className="d-flex flex-column"></div>
                      <p class="Easy-to-use">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          className="mr-1"
                          fill="none"
                          viewBox="0 0 18 18"
                        >
                          <path
                            fill="#17B31B"
                            d="M14.232 3.732c.476-.476 1.248-.476 1.724 0 .439.44.473 1.13.1 1.609l-.1.115-8.38 8.378c-.439.44-1.13.474-1.608.102l-.115-.102-3.809-3.808c-.475-.476-.475-1.248 0-1.724.44-.44 1.131-.473 1.61-.101l.114.101 2.947 2.946 7.517-7.516z"
                          />
                        </svg>{' '}
                        Set traffic range
                      </p>

                      <p class="Easy-to-use">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          className="mr-1"
                          fill="none"
                          viewBox="0 0 18 18"
                        >
                          <path
                            fill="#17B31B"
                            d="M14.232 3.732c.476-.476 1.248-.476 1.724 0 .439.44.473 1.13.1 1.609l-.1.115-8.38 8.378c-.439.44-1.13.474-1.608.102l-.115-.102-3.809-3.808c-.475-.476-.475-1.248 0-1.724.44-.44 1.131-.473 1.61-.101l.114.101 2.947 2.946 7.517-7.516z"
                          />
                        </svg>{' '}
                        Select your own price
                      </p>

                      <p class="Easy-to-use">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          className="mr-1"
                          fill="none"
                          viewBox="0 0 18 18"
                        >
                          <path
                            fill="#17B31B"
                            d="M14.232 3.732c.476-.476 1.248-.476 1.724 0 .439.44.473 1.13.1 1.609l-.1.115-8.38 8.378c-.439.44-1.13.474-1.608.102l-.115-.102-3.809-3.808c-.475-.476-.475-1.248 0-1.724.44-.44 1.131-.473 1.61-.101l.114.101 2.947 2.946 7.517-7.516z"
                          />
                        </svg>
                        Customize sponsored content
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4 col33">
              <div class="card Rectangle-5 mx-auto mx-md-0 mb-6 mb-md-0  ml-md-auto">
                <div class="card-body text-center">
                  <svg
                    className="iconsbrandiconsetup mx-auto"
                    xmlns="http://www.w3.org/2000/svg"
                    width="88"
                    height="88"
                    fill="none"
                    viewBox="0 0 88 88"
                  >
                    <path
                      fill="#48D193"
                      fill-rule="evenodd"
                      d="M44 50.667c3.667 0 6.667 3 6.667 6.666C50.667 61 47.667 64 44 64s-6.667-3-6.667-6.667c0-3.666 3-6.666 6.667-6.666z"
                      clip-rule="evenodd"
                    />
                    <path
                      fill="#48D193"
                      fill-rule="evenodd"
                      d="M20.667 47.333C22.667 47.333 24 46 24 44s-1.333-3.333-3.333-3.333S17.333 42 17.333 44s1.334 3.333 3.334 3.333zm0 26.667c2 0 3.333-1.333 3.333-3.333s-1.333-3.334-3.333-3.334-3.334 1.334-3.334 3.334S18.667 74 20.667 74zM44 70.667c7.333 0 13.333-6 13.333-13.334C57.333 50 51.333 44 44 44s-13.333 6-13.333 13.333c0 7.334 6 13.334 13.333 13.334zm23.333-23.334c2 0 3.334-1.333 3.334-3.333s-1.334-3.333-3.334-3.333S64 42 64 44s1.333 3.333 3.333 3.333zm0 26.667c2 0 3.334-1.333 3.334-3.333s-1.334-3.334-3.334-3.334S64 68.667 64 70.667 65.333 74 67.333 74zm3.334-49.333l-6 1.333L41 30.667h29.667v-6zm-10-12l-27 12.666 27-5.333v-7.333zM4 34v-.333V33v-.333s0-.334.333-.334c0-.333.334-.333.334-.333v-.333s.333 0 .333-.334L5.333 31h.334L62.333 4.333c1-.333 2.334-.333 3.334.334 1 .333 1.666 1.666 1.666 2.666v11.334l6-1.334c1-.333 2 0 2.667.667 1 .667 1.333 1.667 1.333 2.667v10h3.334C82.667 30.667 84 32 84 34v46.667c0 2-1.333 3.333-3.333 3.333H7.333C5.333 84 4 82.667 4 80.667V34z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <div className="row justify-content-center">
                    <div className=" col-12">
                      <p class="Quick-Setup3">Monthly Payments</p>
                    </div>
                  </div>

                  <div className="row justify-content-center  ">
                    <div className="col-12 ">
                      <div className="d-flex flex-column"></div>
                      <p class="Easy-to-use">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          className="mr-1"
                          fill="none"
                          viewBox="0 0 18 18"
                        >
                          <path
                            fill="#17B31B"
                            d="M14.232 3.732c.476-.476 1.248-.476 1.724 0 .439.44.473 1.13.1 1.609l-.1.115-8.38 8.378c-.439.44-1.13.474-1.608.102l-.115-.102-3.809-3.808c-.475-.476-.475-1.248 0-1.724.44-.44 1.131-.473 1.61-.101l.114.101 2.947 2.946 7.517-7.516z"
                          />
                        </svg>{' '}
                        Easy payouts
                      </p>

                      <p class="Easy-to-use">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          className="mr-1"
                          fill="none"
                          viewBox="0 0 18 18"
                        >
                          <path
                            fill="#17B31B"
                            d="M14.232 3.732c.476-.476 1.248-.476 1.724 0 .439.44.473 1.13.1 1.609l-.1.115-8.38 8.378c-.439.44-1.13.474-1.608.102l-.115-.102-3.809-3.808c-.475-.476-.475-1.248 0-1.724.44-.44 1.131-.473 1.61-.101l.114.101 2.947 2.946 7.517-7.516z"
                          />
                        </svg>{' '}
                        No commission cuts
                      </p>

                      <p class="Easy-to-use">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          className="mr-1"
                          fill="none"
                          viewBox="0 0 18 18"
                        >
                          <path
                            fill="#17B31B"
                            d="M14.232 3.732c.476-.476 1.248-.476 1.724 0 .439.44.473 1.13.1 1.609l-.1.115-8.38 8.378c-.439.44-1.13.474-1.608.102l-.115-.102-3.809-3.808c-.475-.476-.475-1.248 0-1.724.44-.44 1.131-.473 1.61-.101l.114.101 2.947 2.946 7.517-7.516z"
                          />
                        </svg>
                        No minimum payout amount
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="section3">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div id="why-cont" className="col-xl-5 col-12 text-center">
              <h1 className="Why-choose-Fly6">Monthly Stats</h1>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-xl-10 col-12 text-center ">
              <h1 className="Getting-started-with-Flyout">
                Flyout has helped millions of people complete over 1.5 million
                sponsered posts for more than 507 advertisers.
              </h1>
            </div>
          </div>

          <div
            style={{ marginTop: '64px' }}
            className="row justify-content-between  "
          >
            <div className="col-12 d-flex flex-column  flex-xl-row  flex-lg-row px-0 justify-content-around">
              <div className="col-lg-2 mr-lg-auto col33  text-center text-md-left">
                <p className="statHead">1203</p>
                <p className="Active-publishers">Active publishers</p>
              </div>

              <div className="col-lg-2   col33  text-center text-md-left">
                <p className="statHead">2316</p>
                <p className="New-publishers-this-month">
                  New publishers this month
                </p>
              </div>

              <div className="col-lg-2  ml-lg-auto  col33 mr-10 text-center text-md-left">
                <p className="statHead">$3,31,001</p>
                <p className="Total-transactions-this-month">
                  Total transactions this month
                </p>
              </div>

              <div className="col-lg-2 ml-lg-auto  col33  text-center text-md-left pl-md-5">
                <p className="statHead">9313</p>
                <p className="Offer-publishers-got-this-month">
                  Offer publishers got this month
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="section4">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div id="why-cont" className="col-xl-5 col-12 text-center">
              <h1 className="Why-choose-Fly6">Success Stories</h1>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-xl-10 col-12 text-center ">
              <h1 className="Getting-started-with-Flyout">
                Meet people doing more of what they love and get inspired by
                people using Flyout to help fund their passions.
              </h1>
            </div>
          </div>

          <div
            id="carouselExampleSlidesOnly"
            className="carousel carousel-fade"
            data-ride="carousel"
            data-interval="4000"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <div style={{ marginTop: '48px' }} className="row">
                  <div
                    style={{ marginTop: '97px' }}
                    className="col-xl-7 col-12 text-left col33"
                  >
                    <div id="section4Column" className="d-flex flex-column ">
                      <svg
                        className="iconstestimonialscomma mx-auto mx-md-0 mx-auto mx-md-0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="88"
                        height="88"
                        fill="none"
                        viewBox="0 0 88 88"
                      >
                        <path
                          fill="#1A181E"
                          d="M88 41.32H66.656c.365 15.837 4.777 17.635 10.318 18.149l2.137.27v17.415l-2.463-.134c-7.236-.415-15.236-1.743-20.573-8.452-4.679-5.88-6.742-15.489-6.742-30.238V11H88v30.32zM38.667 11v30.32h-21.06c.365 15.837 4.635 17.635 10.176 18.149l1.995.27v17.415l-2.321-.134c-7.236-.415-15.308-1.743-20.645-8.452C2.134 62.688 0 53.08 0 38.33V11h38.667z"
                        />
                      </svg>

                      <p
                        style={{ marginTop: '24px' }}
                        id="FaceDesc"
                        className="mb-0 text-center text-md-left"
                      >
                        “I discovered about Flyout through one of the Facebook
                        group and I thought of trying it. Within a time-frame of
                        3 weeks - I got my first sponsored post.”
                      </p>

                      <div
                        style={{ marginTop: '24px' }}
                        className="d-flex flex-column flex-md-row text-center text-md-left mb-6 mb-md-0"
                      >
                        <p className="Ravi-Tamada mb-0">Ravi Tamada </p>
                        <p
                          style={{ marginLeft: '8px' }}
                          className="Founder-Androidhive mb-0"
                        >
                          Founder @ Androidhive
                        </p>
                      </div>

                      <div className="Rectangle-16 d-md-block d-none">
                        <div className="dot-purple "></div>
                        <div className="dot-gray "></div>
                        <div className="dot-gray "></div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-5 col-12 align-content-start px-0 pax-md-4 ">
                    <img
                      className="img-fluid"
                      src="assets/img/testimonial/t1.png"
                      alt=""
                    ></img>
                  </div>
                </div>
              </div>

              <div className="carousel-item ">
                <div style={{ marginTop: '48px' }} className="row">
                  <div
                    style={{ marginTop: '97px' }}
                    className="col-xl-7 col-12 text-left col33"
                  >
                    <div id="section4Column" className="d-flex flex-column ">
                      <svg
                        className="iconstestimonialscomma mx-auto mx-md-0 mx-auto mx-md-0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="88"
                        height="88"
                        fill="none"
                        viewBox="0 0 88 88"
                      >
                        <path
                          fill="#1A181E"
                          d="M88 41.32H66.656c.365 15.837 4.777 17.635 10.318 18.149l2.137.27v17.415l-2.463-.134c-7.236-.415-15.236-1.743-20.573-8.452-4.679-5.88-6.742-15.489-6.742-30.238V11H88v30.32zM38.667 11v30.32h-21.06c.365 15.837 4.635 17.635 10.176 18.149l1.995.27v17.415l-2.321-.134c-7.236-.415-15.308-1.743-20.645-8.452C2.134 62.688 0 53.08 0 38.33V11h38.667z"
                        />
                      </svg>

                      <p
                        style={{ marginTop: '24px' }}
                        id="FaceDesc"
                        className="mb-0 text-center text-md-left"
                      >
                        “I discovered about Flyout through one of the Facebook
                        group and I thought of trying it. Within a time-frame of
                        3 weeks - I got my first sponsored post.”
                      </p>

                      <div
                        style={{ marginTop: '24px' }}
                        className="d-flex flex-column flex-md-row text-center text-md-left mb-6 mb-md-0"
                      >
                        <p className="Ravi-Tamada mb-0">Mir Dawar </p>
                        <p
                          style={{ marginLeft: '8px' }}
                          className="Founder-Androidhive mb-0"
                        >
                          Founder @ Pixul.in
                        </p>
                      </div>

                      <div className="Rectangle-16 d-md-block d-none">
                        <div className="dot-purple "></div>
                        <div className="dot-gray "></div>
                        <div className="dot-gray "></div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-5 col-12 align-content-start px-0 pax-md-4 ">
                    <img
                      className="img-fluid"
                      src="assets/img/photos/photo-16.jpg"
                      alt=""
                    ></img>
                  </div>
                </div>
              </div>

              {/* <div className="carousel-item ">
                <div style={{ marginTop: '48px' }} className="row">
                  <div
                    style={{ marginTop: '97px' }}
                    className="col-xl-7 col-12 text-left col33"
                  >
                    <div id="section4Column" className="d-flex flex-column ">
                      <svg
                        className="iconstestimonialscomma mx-auto mx-md-0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="88"
                        height="88"
                        fill="none"
                        viewBox="0 0 88 88"
                      >
                        <path
                          fill="#1A181E"
                          d="M88 41.32H66.656c.365 15.837 4.777 17.635 10.318 18.149l2.137.27v17.415l-2.463-.134c-7.236-.415-15.236-1.743-20.573-8.452-4.679-5.88-6.742-15.489-6.742-30.238V11H88v30.32zM38.667 11v30.32h-21.06c.365 15.837 4.635 17.635 10.176 18.149l1.995.27v17.415l-2.321-.134c-7.236-.415-15.308-1.743-20.645-8.452C2.134 62.688 0 53.08 0 38.33V11h38.667z"
                        />
                      </svg>

                      <p
                        style={{ marginTop: '24px' }}
                        id="FaceDesc"
                        className="mb-0"
                      >
                        “I discovered about Flyout through one of the Facebook
                        group and I thought of trying it. Within a time-frame of
                        3 weeks - I got my first sponsored post.”
                      </p>

                      <div
                        style={{ marginTop: '24px' }}
                        className="d-flex flex-column flex-md-row text-center text-md-left mb-6 mb-md-0"
                      >
                        <p className="Ravi-Tamada mb-0">Mir Dawar </p>
                        <p
                          style={{ marginLeft: '8px' }}
                          className="Founder-Androidhive mb-0"
                        >
                          Founder @ Pixul
                        </p>
                      </div>

                      <div className="Rectangle-16 d-md-block d-none">
                        <div className="dot-purple "></div>
                        <div className="dot-gray "></div>
                        <div className="dot-gray "></div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-5 col-12 align-content-start  ">
                    <img src="assets/img/photos/photo-16.jpg" alt=""></img>
                  </div>
                </div>
              </div> */}

              {/* 
              <div className="carousel-item">
                <div style={{ marginTop: '48px' }} className="row">
                  <div
                    style={{ marginTop: '97px' }}
                    className="col-xl-7 col-12 text-left col33"
                  >
                    <div id="section4Column" className="d-flex flex-column ">
                      <svg
                        className="iconstestimonialscomma"
                        xmlns="http://www.w3.org/2000/svg"
                        width="88"
                        height="88"
                        fill="none"
                        viewBox="0 0 88 88"
                      >
                        <path
                          fill="#1A181E"
                          d="M88 41.32H66.656c.365 15.837 4.777 17.635 10.318 18.149l2.137.27v17.415l-2.463-.134c-7.236-.415-15.236-1.743-20.573-8.452-4.679-5.88-6.742-15.489-6.742-30.238V11H88v30.32zM38.667 11v30.32h-21.06c.365 15.837 4.635 17.635 10.176 18.149l1.995.27v17.415l-2.321-.134c-7.236-.415-15.308-1.743-20.645-8.452C2.134 62.688 0 53.08 0 38.33V11h38.667z"
                        />
                      </svg>
                      <p style={{ marginTop: '24px' }} id="FaceDesc">
                        “I've been frusratated with the low CPC rates from
                        Google AdSense and a friend of mine recommended me to
                        Flyout. I've listed total 5 blogs of mine.
                      </p>

                      <div
                        style={{ marginTop: '24px' }}
                        className="d-flex flex-row"
                      >
                        <p className="Ravi-Tamada ">Pradeep Kumar</p>
                        <p
                          style={{ marginLeft: '9px' }}
                          className="Founder-Androidhive"
                        >
                          Founder @ Cryptoground
                        </p>
                      </div>
                      <div className="Rectangle-16">
                        <div className="dot-purple "></div>
                        <div className="dot-gray "></div>
                        <div className="dot-gray "></div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-5 col-12 align-content-start ">
                    <img src="assets/img/photos/photo-16.jpg" alt=""></img>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      <section
        id="section5"
        className="row justify-content-center mt-6 text-center mt-10 mt-md-10 px-lg-14"
      >
        <div
          style={{
            paddingTop: '65px',
            paddingBottom: '63px',
            marginBottom: '81px',
            maxWidth: '1120px',
          }}
          className="col Rectangle-13 "
        >
          <h2 className="Get-started-with-Flyout-today ">
            Get started with Flyout today
          </h2>

          <p className="Flyout-is-a-free mb-8 mb-md-0 px-2 px-md-0">
            Flyout is a free, simple way to earn money by placing sponsored
            content on your blog.
          </p>

          <div style={{ paddingTop: '40px' }} className="px-1 flex-lg-row">
            <a className="btn buttonsprimary mb-4 mb-md-0" href="/">
              {' '}
              Get Started
            </a>

            <a
              className="btn btn-outline px-1 buttonssecondary mal-md-4"
              href="/"
            >
              {' '}
              Join Flyout Community
            </a>
          </div>
        </div>
      </section>

      <footer className="">
        <div className="container-fluid text-center text-md-left px-0">
          <div className="row">
            <div className="col-12 col-md-4 col-lg-3 order-md-0 order-2 align-items-center">
              {/* Brand */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="116"
                height="64"
                fill="none"
                viewBox="0 0 116 64"
              >
                <path
                  fill="#7442D3"
                  d="M87.616 28.125c-1.066 2.118-4.936 2.727-8.052 2.717-2.896 0-4.162-.382-6.316-1.157.492-3.555 2.322-18.929 24.208-27.794.826-.33 1.726-.703 2.646-1.013.523 1.323.795 2.728.816 4.144-.011 6.612-6.683 10.952-13.375 13.07 3.587-.103 9.234-1.23 13.343-2.139v.114c-.01 5.92-6.724 9.795-12.57 9.784-1.913-.04-3.816-.32-5.657-.816 1.13 1.602 3.012 2.48 4.957 3.09z"
                />
                <path
                  fill="#000"
                  d="M9.659 55.042H4.462V30.926h17.275v4.516H9.659v5.093h11.816v4.516H9.66v9.99zM28.879 55.04h-4.654V30.925h4.643V55.04h.01zM32.79 61.88l.69-4.123c.44.197.93.29 1.464.29 1.244 0 2.06-.424 2.457-1.271l.66-1.478-7.174-17.72h4.977l4.612 12.151 4.611-12.15h5.01l-8.304 20.323c-.606 1.54-1.464 2.624-2.562 3.234-1.098.61-2.478.95-4.13.992-.858 0-1.632-.083-2.311-.248zM66.828 52.819c-1.705 1.766-3.974 2.655-6.808 2.655-2.834 0-5.093-.889-6.787-2.655-1.694-1.767-2.54-3.947-2.54-6.53s.846-4.753 2.54-6.51c1.694-1.756 3.964-2.634 6.787-2.634 2.834 0 5.103.878 6.807 2.634 1.705 1.757 2.563 3.927 2.563 6.51 0 2.583-.858 4.752-2.563 6.53zm-10.102-2.893c.805.97 1.903 1.467 3.294 1.467 1.39 0 2.5-.486 3.315-1.467.815-.972 1.223-2.19 1.223-3.637 0-1.426-.408-2.625-1.223-3.596-.816-.971-1.924-1.467-3.315-1.467-1.39 0-2.489.486-3.294 1.467-.805.971-1.203 2.18-1.203 3.596 0 1.446.398 2.655 1.203 3.637zM88.683 55.04H84.04v-2.2c-1.59 1.756-3.66 2.634-6.222 2.634-1.903 0-3.325-.486-4.277-1.447-.952-.96-1.433-2.314-1.433-4.05V37.58h4.643v10.59c0 2.15 1.088 3.224 3.252 3.224 1.632 0 2.98-.662 4.026-1.994v-11.82h4.643V55.04h.01zM98.858 55.474c-1.632 0-2.876-.413-3.734-1.23-.857-.816-1.275-2.004-1.275-3.544v-9.113H90.92V37.58h2.928v-4.774h4.684v4.774h3.587v4.008h-3.587v7.884c0 .558.147 1.013.44 1.374.292.362.68.537 1.171.537.732 0 1.265-.165 1.61-.506l.994 3.472c-.868.754-2.165 1.126-3.89 1.126zM106.951 31.483h-1.359v4.205h-.617v-4.205h-1.36v-.569h3.336v.569zm5.48 4.215h-.617v-3.947l-1.642 3.947h-.178l-1.641-3.947v3.947h-.617v-4.773h.941l1.401 3.471 1.401-3.471h.941v4.773h.011z"
                />
              </svg>
            </div>

            <div className="col-12 col-lg-9 col-md-4 px-0 d-flex pl-4 justify-content-between flex-md-row flex-column ">
              {/* 
              <div className="col-6"></div>
              <div className="col-6"></div>
              <div className="col-6"></div> */}

<h1 style={{fontSize: '18px'}} class="d-block d-md-none font-weight-bolder mb-5">Quick Links</h1>

              <div className="col col-md-4 col-lg-2 px-0">
                <ul className="list-unstyled text-gray-800 mb-6 mb-md-8 mb-lg-0">
                  <li className="mb-3">
                    <a href="index.html#!" className="text-reset">
                      Contact
                    </a>
                  </li>
                  <li className="mb-3">
                    <a href="index.html#!" className="text-reset">
                      FAQ's{' '}
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col col-md-4 col-lg-2 px-0">
                <ul className="list-unstyled text-gray-800 mb-6 mb-md-8 mb-lg-0">
                  <li className="mb-3">
                    <a href="index.html#!" className="text-reset">
                      Help Center
                    </a>
                  </li>
                  <li className="mb-3">
                    <a href="index.html#!" className="text-reset">
                      Blog
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col col-md-4 col-lg-2 px-0">
                <ul className="list-unstyled text-gray-800 mb-0 mb-6 mb-md-8 mb-lg-0">
                  <li className="mb-3">
                    <a href="index.html#!" className="text-reset">
                      Privacy
                    </a>
                  </li>
                  <li className="mb-3">
                    <a href="index.html#!" className="text-reset">
                      Terms
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col col-md-4 col-lg-2 px-0">
                <ul className="list-unstyled text-gray-800  mb-6 mb-md-8 mb-lg-0">
                  <li className="mb-3">
                    <a href="index.html#!" className="text-reset">
                      Affiliate Policy
                    </a>
                  </li>
                  <li className="mb-3">
                    <a href="index.html#!" className="text-reset">
                      Data Policy
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col col-md-4 col-lg-2 px-0 px-md-6">
                <ul className="list-unstyled text-gray-800  mb-6 mb-md-8 mb-lg-0">
                  <li className="mb-3">
                    <a href="index.html#!" className="text-reset">
                      Facebook
                    </a>
                  </li>
                  <li className="mb-3">
                    <a href="index.html#!" className="text-reset">
                      Twitter
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* / .row */}

          <div className="footerBorder"></div>

          <div className="row justify-content-center">
            <div className="col-12 FLYOUT-2020 text-center">
              Flyout 2020, All rights reserved.
            </div>
          </div>
        </div>

        {/* / .container */}
      </footer>
    </div>
  );
}

export default App;
